const rankingData = [
  { rank: 1, title: '某顶流艺人深夜密会疑似新恋情曝光', heat: '98.7万', tag: '爆', change: 'up' },
  { rank: 2, title: '知名品牌代言人陷入合同纠纷内幕', heat: '86.2万', tag: '热', change: 'up' },
  { rank: 3, title: '网红主播被曝数据造假背后产业链', heat: '74.5万', tag: '热', change: 'new' },
  { rank: 4, title: '某综艺节目录制现场突发争议事件', heat: '63.1万', tag: '', change: 'up' },
  { rank: 5, title: '娱乐圈新晋CP疑似因戏生情实锤', heat: '51.8万', tag: '', change: 'down' },
  { rank: 6, title: '某上市公司高管桃色新闻持续发酵', heat: '42.3万', tag: '', change: 'up' },
  { rank: 7, title: '热播剧主演片场耍大牌遭剧组爆料', heat: '35.6万', tag: '新', change: 'new' },
];

export default function SectionRanking() {
  return (
    <section id="ranking" className="py-12 md:py-16 px-4 md:px-6 bg-background-50">
      <div className="w-full max-w-[960px] mx-auto">
        <div className="flex items-center gap-3 mb-8">
          <span className="w-10 h-10 flex items-center justify-center rounded-xl bg-primary-100">
            <i className="ri-fire-fill text-primary-500 text-xl"></i>
          </span>
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900">
            热度飙升榜
          </h2>
          <span className="text-xs text-foreground-500 bg-background-200 px-2.5 py-1 rounded-full whitespace-nowrap">实时更新</span>
        </div>

        <div className="space-y-2">
          {rankingData.map((item) => (
            <div
              key={item.rank}
              className="flex items-center gap-4 p-4 rounded-xl bg-background-100 hover:bg-background-200 transition-colors duration-200 cursor-pointer group"
            >
              <span className={`w-8 h-8 flex items-center justify-center rounded-lg font-bold text-sm shrink-0 ${
                item.rank <= 3
                  ? 'bg-primary-500 text-background-50'
                  : 'bg-background-300 text-foreground-600'
              }`}>
                {item.rank}
              </span>
              <span className="flex-1 text-sm md:text-base text-foreground-800 font-medium truncate group-hover:text-primary-600 transition-colors">
                {item.title}
              </span>
              {item.tag && (
                <span className={`shrink-0 text-xs px-2 py-0.5 rounded font-medium whitespace-nowrap ${
                  item.tag === '爆'
                    ? 'bg-primary-500 text-background-50'
                    : item.tag === '新'
                    ? 'bg-accent-500 text-background-50'
                    : 'bg-primary-100 text-primary-700'
                }`}>
                  {item.tag}
                </span>
              )}
              <span className="shrink-0 text-xs text-foreground-500 w-14 text-right">
                {item.heat}
              </span>
              <span className="shrink-0 w-5 h-5 flex items-center justify-center">
                <i className={`text-sm ${
                  item.change === 'up' ? 'ri-arrow-up-line text-primary-500' :
                  item.change === 'down' ? 'ri-arrow-down-line text-accent-600' :
                  'ri-add-line text-accent-500'
                }`}></i>
              </span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}